import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import ProvideEmailForm from '../../../containers/SignUp/ProvideIdentity/ProvideEmailForm';

class ProvideEmailPage extends React.Component {
  UNSAFE_componentWillMount() {
    const { history, userEmail, loginType } = this.props;
    if (userEmail || (loginType === 'singleSignOn')) {
      history.push('/dashboard');
    }
  }

  componentDidMount() {
    this.allowRouteToChange = false;

    if (this.props.history) {
      this.unblockRouter = this.props.history.block((next) => {
        if (next.pathname === '/' || next.pathname === '/dashboard') {
          this.allowRouteToChange = true;
        }
        return this.allowRouteToChange;
      });
    }
  }

  componentWillUnmount() {
    if (this.unblockRouter) {
      this.unblockRouter();
    }
  }

  render() {
    return (
      <div className="col">
        <ProvideEmailForm languageCode={this.props.languageCode} />
      </div>
    );
  }
}

ProvideEmailPage.propTypes = {
  history: PropTypes.object,
  userEmail: PropTypes.string,
  loginType: PropTypes.string,
  languageCode: PropTypes.string,
};

const mapStateToProps = (state) => ({
  languageCode: state.language.languageCode,
  userEmail: state.profile.user.email,
  loginType: state.profile.auth.loginType,
});

export default withRouter(connect(mapStateToProps)(ProvideEmailPage));
